import { LTF_CURRENCY_LIST } from 'src/constants/common';
import { INSTALLMENT_PLANS } from 'src/constants/learn-more';
import { type CurrencyType } from 'src/types/currency';

import { type DecisionInstallment, type WidgetDecisionInput } from './types';

export type ProductFacts = Readonly<{
  installments: readonly DecisionInstallment[];
  hasInstallments: boolean;
  shouldShowLongTermContent: boolean;
  shouldOpenLongTermLearnMore: boolean;
  hasValidMonthlyBillingDate: boolean;
  payInFullAvailable: boolean;
}>;

const isValidDate = (value: string | undefined) => {
  if (!value) return false;

  return !Number.isNaN(new Date(value).getTime());
};

export const deriveProductFacts = (
  input: WidgetDecisionInput
): ProductFacts => {
  const installments = input.offers.installments ?? [];
  const hasInstallments = installments.length > 0;
  const hasBackendLongTermInstallment = installments.some(
    (installment) => installment.paymentsCount > INSTALLMENT_PLANS.four
  );
  const shouldShowLongTermContent = hasInstallments
    ? hasBackendLongTermInstallment
    : input.formattedCurrency === 'AED' || input.formattedCurrency === 'SAR';
  const shouldOpenLongTermLearnMore =
    hasInstallments ||
    LTF_CURRENCY_LIST.includes(input.formattedCurrency as CurrencyType);
  const hasValidMonthlyBillingDate = Boolean(
    input.offers.monthlyBilling?.available &&
      isValidDate(input.offers.monthlyBilling.paymentDate)
  );
  return {
    installments,
    hasInstallments,
    shouldShowLongTermContent,
    shouldOpenLongTermLearnMore,
    hasValidMonthlyBillingDate,
    payInFullAvailable: input.offers.payInFull?.available === true,
  };
};
